const heroTextBlocks = Array.from(document.querySelectorAll('.hero-text'));

if (heroTextBlocks.length > 0) {
  const RESIZE_DEBOUNCE_MS = 150;
  const FOCUS_BOTTOM_GAP = 64;
  const linkTopMap = new WeakMap();
  const links = heroTextBlocks.flatMap((block) => Array.from(block.querySelectorAll('a')));

  let isReverseTabbing = false;
  let resizeTimer = null;

  const getElementTopFromDocument = (element) => {
    let top = 0;
    let current = element;

    while (current) {
      top += current.offsetTop || 0;
      current = current.offsetParent;
    }

    return top;
  };

  const setStickyState = (isSticky) => {
    heroTextBlocks.forEach((block) => {
      if (!isSticky) {
        block.classList.remove('is-sticky');
      } else {
        const fitsInViewport = block.offsetHeight <= window.innerHeight;
        block.classList.toggle('is-sticky', fitsInViewport);
      }
    });
  };

  const cacheLinksTop = () => {
    setStickyState(false);

    links.forEach((link) => {
      linkTopMap.set(link, getElementTopFromDocument(link));
    });

    setStickyState(true);
  };

  const scrollToCachedLinkTop = (link) => {
    const top = linkTopMap.get(link);

    if (typeof top !== 'number') {
      return;
    }

    const linkHeight = link.offsetHeight || 0;
    const focusTopOffset = window.innerHeight - linkHeight - FOCUS_BOTTOM_GAP;

    window.scrollTo({
      top: Math.max(0, top - focusTopOffset),
      behavior: 'auto',
    });
  };

  const initLinkFocusHandlers = () => {
    links.forEach((link) => {
      link.addEventListener('focusin', () => {
        if (!isReverseTabbing) {
          return;
        }

        scrollToCachedLinkTop(link);
      });
    });
  };

  const initGlobalHandlers = () => {
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(cacheLinksTop, RESIZE_DEBOUNCE_MS);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        isReverseTabbing = event.shiftKey;
      }
    });
  };

  const init = () => {
    cacheLinksTop();
    initLinkFocusHandlers();
    initGlobalHandlers();
  };

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init, { once: true });
  }
}
